import React from "react";
import ReactDOM from "react-dom";
import { twClassNames } from "../helpers/twClassNames";

type LoadingSpinnerProps = { status?: string; message?: string };

export function LoadingSpinner({ status, message }: LoadingSpinnerProps) {
    const statusString = status || "Loading...";
    const detailString = message || "This may take a few seconds, please don't close this page.";

    return ReactDOM.createPortal(
        <div>
            <div className="fixed bottom-0 left-0 right-0 top-0 z-[99] h-screen w-full overflow-hidden bg-gray-700 opacity-75"></div>
            <div className="fixed bottom-0 left-0 right-0 top-0 z-[99] flex h-screen w-full flex-col items-center justify-center overflow-hidden">
                <div className="loader mb-4 h-12 w-12 rounded-full border-4 border-t-4 border-gray-200 ease-linear"></div>
                <h2 className="text-center text-xl font-semibold text-white">{statusString}</h2>
                <p className="w-1/3 text-center text-white">{detailString}</p>
            </div>
        </div>,
        document.getElementById("rf-portal-root")
    );
}

type InlineLoadingSpinnerProps = { text?: string; className?: string; iconClassName?: string };

export function InlineLoadingSpinner({
    text = "",
    className,
    iconClassName
}: InlineLoadingSpinnerProps) {
    return (
        <div
            className={twClassNames(
                "flex w-full flex-col items-center justify-center gap-2",
                className
            )}
        >
            <i
                className={twClassNames(
                    "fa-spin far fa-spinner text-2xl text-brand",
                    iconClassName
                )}
            />
            {text && <p className="animate-pulse text-sm font-medium text-secondary">{text}</p>}
        </div>
    );
}
